var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"mx-auto"},[_vm._v("กำลังกลับไปที่ CMU i-Health")])}
var staticRenderFns = []

export { render, staticRenderFns }